import OfflineModule from '../storeModules/offline';

export default {
  install(Vue, { store }) {
    /**
     * Deve essere necessariamente passata l'istanza di vuex store
     */
    if(!store) {
      throw new Error("Please provide vuex store");
    }

    /**
     * Registrazione del modulo dello store associato al menu
     */
    store.registerModule('offline', OfflineModule);
  }
}